import { useState, useRef, useEffect } from 'react';
import { categories } from '@/pages/home/data/categories';

const categoryImages: Record<string, string> = {
  'Shoes': 'https://readdy.ai/api/search-image?query=Single%20pair%20of%20cream%20white%20fashion%20sneakers%20on%20a%20light%20wooden%20surface%2C%20minimal%20product%20photography%2C%20soft%20neutral%20background%2C%20clean%20aesthetic%2C%20natural%20daylight%2C%20no%20text%20or%20logos&width=400&height=400&seq=cat-img-shoes-v2&orientation=squarish',
  'Hoodies/Sweaters': 'https://readdy.ai/api/search-image?query=Single%20folded%20beige%20hoodie%20on%20a%20light%20wooden%20surface%2C%20minimal%20product%20photography%2C%20soft%20neutral%20background%2C%20clean%20aesthetic%2C%20natural%20daylight&width=400&height=400&seq=cat-img-hoodies-v2&orientation=squarish',
  'T-Shirts': 'https://readdy.ai/api/search-image?query=Single%20neatly%20folded%20white%20t-shirt%20on%20a%20light%20wooden%20surface%2C%20minimal%20product%20photography%2C%20soft%20neutral%20background%2C%20clean%20aesthetic%2C%20natural%20daylight&width=400&height=400&seq=cat-img-tshirts-v2&orientation=squarish',
  'Jackets': 'https://readdy.ai/api/search-image?query=Single%20olive%20green%20lightweight%20jacket%20draped%20on%20a%20wooden%20hanger%2C%20minimal%20product%20photography%2C%20soft%20neutral%20background%2C%20clean%20aesthetic%2C%20natural%20daylight&width=400&height=400&seq=cat-img-jackets-v2&orientation=squarish',
  'Pants/Shorts': 'https://readdy.ai/api/search-image?query=Single%20pair%20of%20neatly%20folded%20beige%20linen%20pants%20on%20a%20light%20wooden%20surface%2C%20minimal%20product%20photography%2C%20soft%20neutral%20background%2C%20clean%20aesthetic%2C%20natural%20daylight&width=400&height=400&seq=cat-img-pants-v2&orientation=squarish',
  'Headwear': 'https://readdy.ai/api/search-image?query=Single%20minimal%20cream%20colored%20baseball%20cap%20on%20a%20light%20wooden%20surface%2C%20minimal%20product%20photography%2C%20soft%20neutral%20background%2C%20clean%20aesthetic%2C%20natural%20daylight&width=400&height=400&seq=cat-img-headwear-v2&orientation=squarish',
  'Sets': 'https://readdy.ai/api/search-image?query=Matching%20beige%20hoodie%20and%20jogger%20set%20neatly%20folded%20together%20on%20a%20light%20wooden%20surface%2C%20minimal%20product%20photography%2C%20soft%20neutral%20background%2C%20clean%20aesthetic&width=400&height=400&seq=cat-img-sets-v2&orientation=squarish',
  'Underwear/Underpants': 'https://readdy.ai/api/search-image?query=Set%20of%20neatly%20folded%20neutral%20colored%20cotton%20underwear%20on%20a%20light%20wooden%20surface%2C%20minimal%20product%20photography%2C%20soft%20background%2C%20clean%20aesthetic&width=400&height=400&seq=cat-img-underwear-v2&orientation=squarish',
  'Jersey': 'https://readdy.ai/api/search-image?query=Single%20white%20sports%20jersey%20neatly%20folded%20on%20a%20light%20wooden%20surface%2C%20minimal%20product%20photography%2C%20soft%20neutral%20background%2C%20clean%20aesthetic%2C%20natural%20daylight&width=400&height=400&seq=cat-img-jersey-v2&orientation=squarish',
  'Accessories': 'https://readdy.ai/api/search-image?query=Minimal%20gold%20toned%20watch%20and%20bracelet%20set%20on%20a%20light%20marble%20surface%2C%20minimal%20product%20photography%2C%20soft%20neutral%20background%2C%20clean%20aesthetic&width=400&height=400&seq=cat-img-accessories-v2&orientation=squarish',
  'Bags': 'https://readdy.ai/api/search-image?query=Single%20minimal%20canvas%20tote%20bag%20on%20a%20light%20wooden%20surface%2C%20minimal%20product%20photography%2C%20soft%20neutral%20background%2C%20clean%20aesthetic%2C%20natural%20daylight&width=400&height=400&seq=cat-img-bags-v2&orientation=squarish',
  'Belts': 'https://readdy.ai/api/search-image?query=Single%20minimal%20leather%20belt%20coiled%20on%20a%20light%20wooden%20surface%2C%20minimal%20product%20photography%2C%20soft%20neutral%20background%2C%20clean%20aesthetic&width=400&height=400&seq=cat-img-belts-v2&orientation=squarish',
  'Perfumes': 'https://readdy.ai/api/search-image?query=Single%20minimal%20glass%20perfume%20bottle%20on%20a%20light%20marble%20surface%2C%20minimal%20product%20photography%2C%20soft%20neutral%20background%2C%20clean%20aesthetic&width=400&height=400&seq=cat-img-perfumes-v2&orientation=squarish',
  'Other Stuff': 'https://readdy.ai/api/search-image?query=Minimal%20assortment%20of%20lifestyle%20accessories%20including%20sunglasses%20and%20a%20wallet%20on%20a%20light%20wooden%20surface%2C%20minimal%20product%20photography%2C%20soft%20neutral%20background%2C%20clean%20aesthetic&width=400&height=400&seq=cat-img-other-v2&orientation=squarish',
};

export default function CategorySection() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (url: string) => {
    setDropdownOpen(false);
    window.open(url, '_blank', 'noopener,nofollow');
  };

  return (
    <section id="categories" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            Browse pandabuyspreadsheet Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Select a category from the dropdown or click any card below to discover curated spreadsheet finds on kaspreadsheet.com
          </p>
        </div>

        <div className="flex justify-center mb-8" ref={dropdownRef}>
          <div className="relative w-full max-w-md">
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="w-full flex items-center justify-between px-4 py-3 bg-background-100 border border-background-300/60 rounded-lg text-sm text-foreground-700 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <span className="flex items-center gap-2">
                <i className="ri-menu-search-line text-foreground-500"></i>
                <span>Select a Category to Explore</span>
              </span>
              {dropdownOpen ? (
                <i className="ri-arrow-up-s-line text-foreground-400"></i>
              ) : (
                <i className="ri-arrow-down-s-line text-foreground-400"></i>
              )}
            </button>

            {dropdownOpen && (
              <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200/60 rounded-lg overflow-hidden z-40 dropdown-animate max-h-64 overflow-y-auto">
                {categories.map((cat) => (
                  <button
                    key={cat.name}
                    onClick={() => handleSelect(cat.url)}
                    className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 transition-colors text-left cursor-pointer"
                  >
                    <span className="text-sm font-medium">{cat.name}</span>
                    <i className="ri-external-link-line ml-auto text-foreground-400 text-xs"></i>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="category-card group flex flex-col bg-background-50 border border-background-200/60 rounded-lg overflow-hidden hover:border-accent-300/60 transition-all duration-200 cursor-pointer"
            >
              <div className="w-full h-28 md:h-32 overflow-hidden">
                <img
                  src={categoryImages[cat.name]}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="p-3 md:p-4 text-center">
                <span className="text-xs md:text-sm font-medium text-foreground-700 whitespace-nowrap">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}